export function getImagesByColor(productData: Product) {
  const colorGroups = {} as Record<string, { color: string; images: Mediagallery[] }>

  // Group variants by color
  productData?.variants?.forEach((variant) => {
    const colorAttr = variant?.attributes?.find((attr) => attr?.code === 'color')
    const color = colorAttr?.label

    if (!color) return

    const images = variant?.product?.media_gallery || []

    // If this color doesn't exist yet, or if this variant has more images
    if (!colorGroups[color] || images.length > colorGroups[color].images.length) {
      colorGroups[color] = {
        color: color,
        images: images,
      }
    }
  })

  return Object.values(colorGroups)
}

export const PREFIX_URL = `https://api.hydrashop.vn/media/catalog/product/cache/0f31f40f97bb30e1f91036dc0da98d09`
export const isStartWithHttp = (url: string | null) => {
  if (!url) return false
  return url.startsWith('http://') || url.startsWith('https://')
}
